import * as React from 'react';
import './Rules.css';


class Rules extends React.Component<object, object> {


  public constructor(props: object) {

    super(props);
  }


  public render() {

    return (
      <div className="rules" style={{
        alignItems: 'center', display: "flex", flexDirection: "column",
        justifyContent: 'center'
      }}>
        <div className="rules">
          <h2>Acceptation d'utilisation du site</h2>
          <label>ADETEC SAS vous fournit sur le site smart-tx.io des services sous réserve que vous acceptiez les différentes règles définies ci-après. Les règles définies constituent les présentes conditions d'utilisation. Utiliser les services du site signifie que vous acceptez ces conditions. </label>
          <h2>Enregistrement et protection des données</h2>
          <label>Pour l'utilisation de la globalité des services en ligne, vous devez vous enregistrer. Vous vous engagez à insérer des informations exactes ainsi qu'à maintenir leur mise à jour en cas de changement de votre profil. Conformément à la loi nº 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, les utilisateurs disposent d'un droit d'accès (article 34 et suivants), de suppression ou de modification des données nominatives les concernant (article 36 et suivants). Ils peuvent exercer ce droit en contactant ADETEC SAS par e-mail ou courrier à ADETEC SAS - 8, rue de l’Angoumois 95100 ARGENTEUIL.</label>
          <h2>Identifiant, mot de passe et informations s'y rapportant</h2>
          <label>Pendant la procédure d'enregistrement, vous êtes amené à définir un identifiant ainsi qu'un mot de passe de sécurité. Ces deux éléments constituent le lien vers vos données personnelles sur le site. Vous vous engagez à contacter ADETEC SAS (Tél : 0 825 702 580) pour toutes anomalies constatées, perte de mot de passe ou utilisation abusive d'un tiers afin que le mot de passe soit supprimé. ADETEC SAS ne pourra être tenue responsable pour tout dommage survenu lors de la non-application du présent paragraphe. </label>
          <h2>Utilisateur du site - acceptation</h2>
          <label>En tant qu'utilisateur, vous acceptez : de n'utiliser, exploiter ou diffuser les informations et scripts contenus sur le site qu'en possédant l'accord explicite de ADETEC SAS. de ne pas envoyer au cours des formulaires d'enregistrement ou de la rubrique « Nous contacter » de propos vulgaire, raciste, pornographique ou portant atteinte à la vie privée d'un tiers (personne morale ou physique). Nous vous informons que ADETEC SAS ou un tiers désigné par ADETEC SAS pourra visionner les informations stockées sur nos serveurs en cas de non-respect de la législation en vigueur afin de protéger les droits et intérêts de chacun. Vous reconnaissez le droit à ADETEC SAS de modifier ou supprimer toute information en contradiction avec la bonne utilisation du site et le respect des présentes conditions d'utilisation ainsi que de résilier l'enregistrement d'un individu. </label>
          <h2>Garanties</h2>
          <label>ADETEC SAS ne pourra être tenue responsable des dommages directs et indirects qui pourraient découler de l’utilisation du site, notamment le téléchargement d’informations. </label>
        </div>
      </div>
    );
  }
}


export default Rules;



// WEBPACK FOOTER //
// ./src/pages/Rules.tsx